



























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FunnelData } from "@/types";

@Component
export default class Funnel extends Vue {
  @Prop() data!: any;

  get indicatorsData() {
    if (!this.data) {
      return this.indicators;
    }
    return this.indicators.map((indicator) => ({
      ...indicator,
      number: this.data[indicator.id],
    }));
  }

  indicators: Array<FunnelData> = [
    {
      title: `${this.$t("experts.funnel_experts_text1")}`,
      id: "registered",
    },
    {
      title: `${this.$t("experts.funnel_experts_text2")}`,
      id: "filled_profile"
    },
    {
      title: `${this.$t("experts.funnel_experts_text3")}`,
      id: "approved",
    },
    {
      title: `${this.$t("experts.funnel_experts_text4")}`,
      id: "has_activity",
    },
    {
      title: `${this.$t("experts.funnel_experts_text5")}`,
      id: "has_cooperations"
    }
  ];
}
